"use client";

export default function TrustedByGlobalBrands() {
  const partners = [{
    name: "GLOBAL LEADERSHIP SUMMIT"
  }, {
    name: "TECHCORP INTERNATIONAL"
  }, {
    name: "VANGUARD STRATEGIES"
  }, {
    name: "ELITE PERFORMANCE EXPO"
  }, {
    name: "MODERN EXECUTIVE FORUM"
  }, {
    name: "RESILIENCE CON"
  }, {
    name: "EMPATHY IN ACTION"
  }, {
    name: "THE COMMAND STAGE"
  }, {
    name: "PEAK POTENTIAL"
  }, {
    name: "SYNERGY NETWORKS"
  }];
  const loopPartners = [...partners, ...partners];
  return <section data-section-id="3794" id="trusted-by-global-brands" className="relative bg-background text-foreground border-y border-border/10 overflow-hidden">
      <div className="relative h-[200px] md:h-[200px] flex items-center">
        {}
        <div className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-10 hidden sm:block">
          
        </div>

        {}
        <div className="absolute left-0 right-0 top-1/2 h-px bg-primary/20 pointer-events-none" />

        {}
        <div className="relative w-full px-4 sm:pl-20 sm:pr-8 md:pl-28 md:pr-12">
          {}
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-32 z-10 bg-gradient-to-r from-background to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-32 z-10 bg-gradient-to-l from-background to-transparent" />

          {}
          <div className="group overflow-hidden">
            <div className="flex items-center gap-16 md:gap-24 whitespace-nowrap" style={{
            animation: "paw-marquee 60s linear infinite",
            width: "max-content"
          }}>
              {loopPartners.map((partner, i) => <div data-index={i} key={i} className="font-mono text-foreground/40 hover:text-primary transition-colors duration-300 font-semibold" style={{
              fontSize: "clamp(14px, 1.4vw, 18px)",
              letterSpacing: "0.15em",
              height: "20px",
              lineHeight: "20px"
            }}>
                  <span className="md:hidden">{partner.name}</span>
                  <span className="hidden md:inline-block" style={{
                height: "28px",
                lineHeight: "28px"
              }}>
                    {partner.name}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        {}
        <div className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-10 hidden lg:block">
          
        </div>
      </div>

      <style>{`
        @keyframes paw-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .group:hover [style*="paw-marquee"] {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}